
import Vue from 'vue';
import LocationsDesktop from './views/locations-desktop.vue';

export default Vue.extend({
  components: {LocationsDesktop}
});
